module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "nav nav-tabs nav-justified"
  }, [_c('li', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsmc'
      }
    }
  }, [_vm._v("\r\n                Hauptartgrp.\r\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'statisticsb'
      }
    }
  }, [_vm._v("\r\n                Marken\r\n            ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    staticStyle: {
      "padding-bottom": "100px"
    }
  }, [_c('div', {
    staticClass: "tab-pane in active",
    attrs: {
      "id": "hk"
    }
  }, [_c('div', {
    staticClass: "rowX text-center"
  }, [_c('settings', {
    attrs: {
      "mode": "first"
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary active",
    on: {
      "click": function($event) {
        _vm.drawChart()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "checked": ""
    }
  }), _vm._v(" Umsatz\r\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.drawChart(true)
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off"
    }
  }), _vm._v(" Quoten\r\n                    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-colored card-table"
  }, [_c('tbody', _vm._l((_vm.years[0]), function(year, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "tag": "tr",
        "to": {
          name: 'statisticsby',
          params: {
            year: year.jahr
          }
        }
      }
    }, [_c('td', [_vm._v(_vm._s(year.jahr))]), _vm._v(" "), _c('td', [_vm._v("\r\n                                " + _vm._s(_vm._f("myCurrency")(year.umsatz)) + " €\r\n                            ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "1%"
      }
    }, [_c('span', {
      staticClass: "next"
    })])])
  }))])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "30px"
    }
  }, [_c('div', {
    staticClass: "chart",
    attrs: {
      "id": "yCustomerChart"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-383df0d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/Dashboard/Brand.html
// module id = 555
// module chunks = 1